import { computed, defineComponent, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { UploadFilled, Download } from '@element-plus/icons-vue';
import { Actions as UploadActions } from '@/store/enums/hrgs/UploadEnum';
import { ElLoading } from 'element-plus';
export default defineComponent({
    components: { UploadFilled, Download },
    props: {
        modelValue: String,
        accept: {
            type: String,
            default: '.jpeg, .jpg, .png'
        },
        uploadAction: {
            type: String,
            default: UploadActions.UPLOAD_IMAGE
        },
        disabled: Boolean,
        isImage: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:modelValue', 'input', 'uploaded'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        const store = useStore();
        const uploadRef = ref();
        const fileList = ref([]);
        const defaultFileList = ref([]);
        watch(() => {
            return props.modelValue;
        }, (value) => {
            var _a, _b;
            if (value) {
                defaultFileList.value = [
                    {
                        name: ((_b = (_a = value === null || value === void 0 ? void 0 : value.split('/')) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.split('?')[0]) || '',
                        url: value
                    }
                ];
            }
            else {
                defaultFileList.value = [];
            }
        }, {
            immediate: true
        });
        const filesInput = computed(() => {
            if (fileList.value.length)
                return fileList.value;
            return defaultFileList.value;
        });
        const onRemove = () => {
            value.value = '';
        };
        const onChange = (uploadFile) => {
            defaultFileList.value = [];
            const loading = ElLoading.service({
                lock: true,
                text: 'Uploading...'
            });
            store
                .dispatch(props.uploadAction, {
                request: uploadFile.raw,
                isImage: props.isImage
            })
                .then((resp) => {
                value.value = resp.url;
            })
                .finally(() => {
                loading.close();
            });
        };
        return {
            uploadRef,
            value,
            fileList,
            defaultFileList,
            filesInput,
            onChange,
            onRemove
        };
    }
});
